import moment from "moment";

export const defaultBasket = {
  id: "",
  createdTimeUtc: moment().format(),
  items: [],
};
